import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { UrlType, LinkTargetType } from '../../../core/interface/link';
import { Router } from '@angular/router';

@Component({
  selector: 'a[ubl-link]',
  template: '<ng-content></ng-content>',
  styles: []
})
export class UblLinkComponent implements OnInit {
  @Input('ubl-link') type: UrlType;
  @Input('ubl-link-target') target: LinkTargetType;

  constructor(
    private elRef: ElementRef<HTMLLinkElement>,
    private router: Router
  ) { }

  ngOnInit()
  {
    if (this.elRef && this.type === UrlType.Node && this.target !== '_blank')
    {
      const link = this.elRef.nativeElement;

      link.addEventListener('click', this.handleClick.bind(this));
    }
  }

  ngOnDestroy()
  {
    if (this.elRef)
    {
      this.elRef.nativeElement.removeEventListener('click', this.handleClick);
    }
  }

  private handleClick(ev: MouseEvent)
  {
    ev.preventDefault();
    const url = this.trimTrailingSlash((ev.currentTarget as any).pathname);

    this.router.navigate([url]);
  }

  private trimTrailingSlash(str: string)
  {
    return str.replace(/\/$/, '');
  }
}
